import { lazy, Suspense } from 'react';

import AcceptInvitationPage from '../pages/common/auth/accept-invitation.page';
import ForgotPasswordPage from '../pages/common/auth/forgot-password.page';
import ResetPasswordPage from '../pages/common/auth/reset-password.page';
import VerifyEmailPage from '../pages/common/auth/verify-email.page';
import BookDemoPage from '../pages/common/book-demo/book-demo.page';
import { ACCOUNT_PATHS, isAccountPath } from './account-paths';

// Lazy: it brings three.js, which no other signed-out page needs.
const VcamPhonePage = lazy(() => import('../modules/vendor/vcam/phone/VcamPhonePage'));

const PAGES: Record<typeof ACCOUNT_PATHS[number], JSX.Element> = {
    '/invite/:token': <AcceptInvitationPage />,
    '/forgot-password': <ForgotPasswordPage />,
    '/reset-password/:token': <ResetPasswordPage />,
    '/verify-email/:token': <VerifyEmailPage />,
    '/book-demo': <BookDemoPage />,
    // The phone end of the 3D studio's camera link (QR code, no login).
    '/vcam/:code': <Suspense fallback={null}><VcamPhonePage /></Suspense>,
};

/**
 * Pages reached from an emailed or shared link. They work whether or not
 * someone is signed in on this browser: a super admin tries the invitation
 * they just made, a colleague opens a reset link on a shared machine.
 */
export const ACCOUNT_ROUTES = ACCOUNT_PATHS.map((path) => ({ path, element: PAGES[path] }));

export { isAccountPath };
